import { createContext, useContext, useReducer } from "react";

export const ChooseContext = createContext({});

export const useChooseContext = () => {
  return useContext(ChooseContext);
};

const reducer = (state, action) => {
  switch (action.type) {
    case "recent":
      return { ...state, isRecent: true, isSelect: false };
    case "select":
      return { ...state, isRecent: false, isSelect: true };
    default:
      throw new Error(`Unhandled action type: ${action.type} `);
  }
};

const initilaState = {
  isRecent: true,
  isSelect: false,
};

export const ChooseContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initilaState);

  const ChooseContextValue = [state, dispatch];

  return (
    <ChooseContext.Provider value={ChooseContextValue}>
      {children}
    </ChooseContext.Provider>
  );
};
